import AnthologyReaderNode from './types/anthology-reader';
import AnthologyWriterNode from './types/anthology-writer';

export const anthologyNodes = {
  anthologyReader: AnthologyReaderNode,
  anthologyWriter: AnthologyWriterNode,
};
